module.exports = __webpack_public_path__ + "static/royal-carib.a93d1363.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/royal-carib.svg
// module id = 423
// module chunks = 59819425949494